import moment from "moment";

const dateFormat = "DD MMM YYYY";

export function formatDate(date, formatDat = dateFormat) {
  return moment(date).format(formatDat);
}

// export function getTimeLeft(date) {
//   if (!date) return { diffTime: "", message: "" };
//
//   const diff = Math.abs(moment().diff(date, "days", true));
//   const diffTime = diff > 1 || diff < -1 ? parseInt(diff, 10) : 1;
//   const isDateAfterNow = moment().isSameOrBefore(date, "days");
//   const message = `day${diffTime === 1 ? "" : "s"} ${
//     isDateAfterNow ? "left" : "overdue"
//   }`;
//   return { diffTime, message };
// }

export const roundToPoint = (value, exponent = 1) => {
  return Math.round(value * 10 ** exponent) / 10 ** exponent;
};

export function formatNumber(number) {
  const num = number ? number.toString() : "0";
  return num.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatPercentage(number) {
  return `${roundToPoint(number * 100, 2)} %`;
}

export function formatDateToApi(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) {
    month = `0${month}`;
  }
  if (day.length < 2) {
    day = `0${day}`;
  }

  return [year, month, day].join("-");
}
